import { render, staticRenderFns } from "./DatesSelector.vue?vue&type=template&id=6ffdc738"
import script from "./DatesSelector.vue?vue&type=script&lang=js"
export * from "./DatesSelector.vue?vue&type=script&lang=js"
import style0 from "./DatesSelector.vue?vue&type=style&index=0&id=6ffdc738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports